export default __webpack_public_path__ + "static/media/Helm of Righteous Smiting.72532a72.jpg";